import { ChevronDown } from "lucide-react";
import React from "react";
import { Button } from "randmarcomps";

interface Props extends React.ComponentPropsWithoutRef<"button"> {
  small?: boolean;
}

const ExpandPanelIcon: React.FC<Props> = ({ small, className, ...props }) => {
  return (
    <Button
      variant="ghost"
      size="icon"
      className={`text-primary p-0 ${className || ""}`}
      {...props}
    >
      <ChevronDown className={small ? "h-6 w-6" : "h-10 w-10"} />
    </Button>
  );
};

export default ExpandPanelIcon;
